// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-models-content .back-to-admin-btn {
  position: absolute;
  right: var(--cds-layout-density-padding-inline-local);
  z-index: 1;
}
.manage-models-content .filter-dropdowns {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.manage-models-content .filter-dropdowns > div {
  padding-right: 2rem;
  width: 100%;
}
.manage-models-content .cds--accordion__wrapper {
  background-color: var(--cds-background);
}
.manage-models-content .cds--accordion__wrapper .cds--accordion__content {
  padding-inline-end: 1rem !important;
}
.manage-models-content .accordion-title {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  margin: 1rem 0;
  align-items: center;
}
.manage-models-content .accordion-title > div {
  font-size: 1.1rem;
  height: fit-content;
}
.manage-models-content .table-row-model-name {
  display: flex;
  align-items: center;
  height: inherit;
  text-wrap: nowrap;
}
.manage-models-content .table-row-model-view {
  height: fit-content;
  min-height: fit-content;
}
.manage-models-content .archive-success-notification {
  position: fixed;
  top: 10%;
  right: 50%;
  left: 50%;
  z-index: 9999;
}
.manage-models-content section.modal-body .row .mb-3 .col-md-2 .num-input-p0 .cds--number label {
  height: 2rem;
}
.manage-models-content .divider {
  width: 100%;
  height: 1px;
  margin: 2rem 0;
  border-bottom: 3px dotted var(--cds-field-02);
}
.manage-models-content .ops-modal .cds--modal-container--lg {
  min-width: 90vw;
  overflow-y: auto;
}
.manage-models-content .cds--pagination, .manage-models-content .cds--pagination__control-buttons, .manage-models-content .cds--text-input, .manage-models-content .cds--text-area, .manage-models-content .cds--search-input, .manage-models-content .cds--select-input, .manage-models-content .cds--dropdown, .manage-models-content .cds--dropdown-list, .manage-models-content .cds--number input[type=number], .manage-models-content .cds--date-picker__input, .manage-models-content .cds--multi-select, .manage-models-content .cds--number__control-btn::before, .manage-models-content .cds--number__control-btn::after {
  background-color: var(--cds-field);
}
.manage-models-content .min-label-height-30 label {
  min-height: 30px;
}
.manage-models-content .min-label-height-30 .static-input {
  min-height: 32px;
  line-height: 1.5;
  padding: 5px 0 5px 0;
}
.manage-models-content .num-input-p0 input {
  padding-right: 0;
}
.manage-models-content .cds--form__helper-text {
  font-size: 1.2rem;
}
.manage-models-content .form-inputs-top {
  margin-top: 1rem;
  margin-bottom: 4rem;
}
.manage-models-content .form-inputs-bottom {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.manage-models-content .fulltime-equations-datatable .wlf-value {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: space-between;
}
.manage-models-content .fulltime-equations-datatable .ft-eqn-select-all {
  opacity: 0;
  pointer-events: none;
}
.manage-models-content .confirmation-modal .cds--modal-content {
  min-height: auto;
}
.manage-models-content tr.cds--parent-row:not(.cds--expandable-row) td,
.manage-models-content tr.cds--parent-row.cds--expandable-row td,
.manage-models-content tr.cds--parent-row.cds--expandable-row {
  min-width: 6rem;
  max-width: 6rem;
  word-wrap: break-word;
}
.manage-models-content .action-buttons .cds--btn--ghost svg {
  fill: var(--cds-link-primary, #0f62fe);
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/CreateModels/CreateModels.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,qDAAA;EACA,UAAA;AAAR;AAGI;EACI,aAAA;EACA,8BAAA;AADR;AAGQ;EACI,mBAAA;EACA,WAAA;AADZ;AAKI;EACI,uCAAA;AAHR;AAKQ;EACI,mCAAA;AAHZ;AAOI;EACI,aAAA;EACA,kCAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AALR;AAOQ;EACI,iBAAA;EACA,mBAAA;AALZ;AASI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAPR;AAUI;EACI,mBAAA;EACA,uBAAA;AARR;AAWI;EACI,eAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AATR;AAiBwB;EACI,YAAA;AAf5B;AA2BI;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,6CAAA;AAzBR;AA4BI;EACI,eAAA;EACA,gBAAA;AA1BR;AA8BI;EAaI,kCAAA;AAxCR;AA4CQ;EACI,gBAAA;AA1CZ;AA6CQ;EACI,gBAAA;EACA,gBAAA;EACA,oBAAA;AA3CZ;AA+CI;EACI,gBAAA;AA7CR;AAgDI;EACI,iBAAA;AA9CR;AAiDI;EACI,gBAAA;EACA,mBAAA;AA/CR;AAkDI;EACI,gBAAA;EACA,mBAAA;AAhDR;AAoDQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAlDZ;AAqDQ;EACI,UAAA;EACA,oBAAA;AAnDZ;AAwDQ;EACI,gBAAA;AAtDZ;AA0DI;;;EAGI,eAAA;EACA,eAAA;EACA,qBAAA;AAxDR;AA2DI;EACI,sCAAA;AAzDR","sourcesContent":[".manage-models-content {\n    .back-to-admin-btn {\n        position: absolute;\n        right: var(--cds-layout-density-padding-inline-local);\n        z-index: 1;\n    }\n\n    .filter-dropdowns {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n\n        &>div {\n            padding-right: 2rem;\n            width: 100%;\n        }\n    }\n\n    .cds--accordion__wrapper {\n        background-color: var(--cds-background);\n\n        .cds--accordion__content {\n            padding-inline-end: 1rem !important;\n        }\n    }\n\n    .accordion-title {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n        width: 100%;\n        margin: 1.0rem 0;\n        align-items: center;\n\n        &>div {\n            font-size: 1.1rem;\n            height: fit-content;\n        }\n    }\n\n    .table-row-model-name {\n        display: flex;\n        align-items: center;\n        height: inherit;\n        text-wrap: nowrap;\n    }\n\n    .table-row-model-view {\n        height: fit-content;\n        min-height: fit-content;\n    }\n\n    .archive-success-notification {\n        position: fixed;\n        top: 10%;\n        right: 50%;\n        left: 50%;\n        z-index: 9999;\n    }\n\n    section.modal-body {\n        .row .mb-3 {\n            .col-md-2 {\n                .num-input-p0 {\n                    .cds--number {\n                        label {\n                            height: 2rem;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .ac-id {\n        // color: themes.$support-info;\n    }\n\n    .divider {\n        width: 100%;\n        height: 1px;\n        margin: 2rem 0;\n        border-bottom: 3px dotted var(--cds-field-02);\n    }\n\n    .ops-modal .cds--modal-container--lg {\n        min-width: 90vw;\n        overflow-y: auto;\n    }\n\n\n    & .cds--pagination,\n    & .cds--pagination__control-buttons,\n    & .cds--text-input,\n    & .cds--text-area,\n    & .cds--search-input,\n    & .cds--select-input,\n    & .cds--dropdown,\n    & .cds--dropdown-list,\n    & .cds--number input[type=\"number\"],\n    & .cds--date-picker__input,\n    & .cds--multi-select,\n    & .cds--number__control-btn::before,\n    & .cds--number__control-btn::after {\n        background-color: var(--cds-field);\n    }\n\n    .min-label-height-30 {\n        label {\n            min-height: 30px;\n        }\n\n        .static-input {\n            min-height: 32px;\n            line-height: 1.5;\n            padding: 5px 0 5px 0;\n        }\n    }\n\n    .num-input-p0 input {\n        padding-right: 0;\n    }\n\n    .cds--form__helper-text {\n        font-size: 1.2rem;\n    }\n\n    .form-inputs-top {\n        margin-top: 1rem;\n        margin-bottom: 4rem;\n    }\n\n    .form-inputs-bottom {\n        margin-top: 2rem;\n        margin-bottom: 2rem;\n    }\n\n    .fulltime-equations-datatable {\n        .wlf-value {\n            display: flex;\n            flex-direction: column;\n            align-self: stretch;\n            justify-content: space-between;\n        }\n\n        .ft-eqn-select-all {\n            opacity: 0;\n            pointer-events: none;\n        }\n    }\n\n    .confirmation-modal {\n        & .cds--modal-content {\n            min-height: auto;\n        }\n    }\n\n    tr.cds--parent-row:not(.cds--expandable-row) td,\n    tr.cds--parent-row.cds--expandable-row td,\n    tr.cds--parent-row.cds--expandable-row {\n        min-width: 6rem;\n        max-width: 6rem;\n        word-wrap: break-word;\n    }\n\n    .action-buttons .cds--btn--ghost svg {\n        fill: var(--cds-link-primary, #0f62fe);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
